<!-- A generative AI model wrote or edited portions of this file with the supervision of a human developer and careful human review. -->
<script>
  import SliderIcon from "$components/Icons/Slider.svelte";
  import { BasicDropdown, logClickToGA } from "@urbaninstitute/dataviz-components";
  let {
    metricSelectionData,
    value = $bindable(),
    toggleControls = () => {},
    controlsOpen
  } = $props();

  let filterLabel = $derived(controlsOpen ? "Close filters" : "Filter data");
</script>

<div class="sticky-control-inner">
  <div class="sticky-metric-selection">
    <div class="sticky-control-label">Select a metric:</div>
    <BasicDropdown
      bind:value
      data={metricSelectionData}
      id="metric-select-sticky"
      inlineLabel=""
      on:change={(e) =>
        logClickToGA(/** @type {HTMLElement} */ (e.currentTarget), "metric-selected-sticky")}
    />
  </div>
  <div class="filter-button">
    <button
      type="button"
      class="btn"
      onclick={(e) => {
        logClickToGA(e.currentTarget, "sticky-filter-toggle");
        toggleControls(e);
      }}
    >
      <span>{filterLabel}</span>
      <SliderIcon fill="black" size={18} />
    </button>
  </div>
</div>

<style>
  .btn {
    border: 2px solid var(--color-black);
    padding: var(--spacing-2);
    background: none;
    display: inline-flex;
    gap: var(--spacing-2);
    align-items: center;
    cursor: pointer;
    font-weight: var(--font-weight-bold);
  }
  .sticky-metric-selection {
    max-width: 50%;
  }
  .sticky-control-inner {
    display: flex;
    justify-content: space-between;
  }
  .sticky-control-label {
    font-weight: var(--font-weight-bold);
    font-family: var(--font-family-sans-alt);
    line-height: 1;
    flex-shrink: 0;
  }
  .sticky-control-inner :global(.dropdown-container) {
    width: 100% !important;
  }
  .sticky-control-inner :global(.dropdown-container select) {
    background-color: transparent !important;
    border-color: transparent !important;
    border-bottom: 2px solid var(--color-blue-shade-darker) !important;
    padding: 0 !important;
    padding-right: var(--spacing-8) !important;
    padding-bottom: var(--spacing-2) !important;
    width: 100% !important;
  }

  .sticky-control-inner :global(.dropdown-container .icons) {
    padding-right: var(--spacing-1) !important;
    transform: translateY(-0.25rem);
  }
  .sticky-control-inner :global(.dropdown-container select:focus:not(:focus-visible)) {
    outline: 0 !important;
  }
  .sticky-control-inner :global(.dropdown-container select:focus-visible) {
    outline: 2px solid var(--color-blue-shade-darker) !important;
    outline-offset: 2px !important;
  }
  .filter-button button {
    color: inherit;
    font-family: inherit;
    font-size: inherit;
  }
  @media (min-width: 768px) {
    .sticky-metric-selection {
      display: flex;
      align-items: center;
      gap: var(--spacing-4);
    }
  }
  @media (min-width: 1024px) {
    .filter-button {
      display: none;
    }
  }
</style>
